export const employeeRoleOptions = [
    {
        displayName: 'Manager',
        value: 'manager',
    },
    {
        displayName: 'Supervisor',
        value: 'supervisor',
    },
    {
        displayName: 'Suite Attendant',
        value: 'suite_attendant',
    },
    {
        displayName: 'Cart Attendant',
        value: 'cart_attendant',
    }
]

export const roleInfo = {
    manager: {
        name: 'Manager',
        abbreviation: "M",
        color: '#17a141',
    },
    supervisor: {
        name: 'Supervisor',
        abbreviation: "S",
        color: 'black',
    },
    suite_attendant: {
        name: 'Suite Attendant',
        abbreviation: "SA",
        color: '#179C8F',
    },
    cart_attendant: {
        name: 'Cart Attendant',
        abbreviation: "CA",
        color: '#e21e5c',
    }
}
